import React from 'react';
import EditIcon from '@material-ui/icons/Create';

const Pencil = (props) => <EditIcon {...props} />;

export default Pencil;
